import { render, staticRenderFns } from "./redirector.vue?vue&type=template&id=56027420&scoped=true"
import script from "./redirector.vue?vue&type=script&lang=js"
export * from "./redirector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56027420",
  null
  
)

export default component.exports